import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO_ROUTES from "../seo/routes.json";

const SITE_URL = "https://arcoorbis2.com";
const PRIVATE_ROUTES = new Set(["/login", "/register", "/admin"]);

function seoFor(pathname) {
  return SEO_ROUTES[pathname] || SEO_ROUTES["/"];
}

function setMeta(selector, attr, value) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export default function RouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    const route = seoFor(normalizedPath);
    const isPrivate = PRIVATE_ROUTES.has(normalizedPath);
    const url = `${SITE_URL}${isPrivate ? "/" : normalizedPath}`;
    document.title = route.title;
    setMeta('meta[name="description"]', "content", route.description);
    setMeta('meta[name="robots"]', "content", isPrivate ? "noindex, nofollow" : "index, follow");
    setMeta('meta[property="og:title"]', "content", route.title);
    setMeta('meta[property="og:description"]', "content", route.description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", route.title);
    setMeta('meta[name="twitter:description"]', "content", route.description);
    let can = document.querySelector('link[rel="canonical"]');
    if (!can) {
      can = document.createElement("link");
      can.setAttribute("rel", "canonical");
      document.head.appendChild(can);
    }
    can.setAttribute("href", url);
  }, [pathname]);
  return null;
}
